export default {"src":"/_next/static/media/giv_font_logo.d253831c.svg","height":60,"width":194,"blurWidth":0,"blurHeight":0};